module.exports = __webpack_public_path__ + "img/99clicks-logo.707ea265.svg";